import {
  MERGE_COMMON_STATE_VARIABLE,
  SET_XCONNECT_CALLBACK_ID,
  SET_COMMON_STATE_VARIABLE,
  SEND_SIGNAL,
  REMOVE_SIGNAL
} from '../actions/reduxTools';

//const immutable = require('object-path-immutable');

const reduxTools = (
  state = {
    xcCallbackIds: {},
    signals: new Map()
  },
  action
) => {
  switch (action.type) {
    case SEND_SIGNAL:
      return {
        ...state,
        signals: new Map(state.signals).set(
          action.signalId,
          action.signalReducer
        )
      };
    case REMOVE_SIGNAL:
      state.signals.delete(action.signalId);
      return {
        ...state,
        signals: new Map(state.signals)
      };
    case SET_XCONNECT_CALLBACK_ID:
      return {
        ...state,
        xcCallbackIds: {
          ...state.xcCallbackIds,
          ...action.callBackId
        }
      };
    case SET_COMMON_STATE_VARIABLE:
      //return immutable.set(state, action.path, action.value);
      break;
    case MERGE_COMMON_STATE_VARIABLE:
      //return immutable.merge(state, action.path, action.obj);
      break;
    default:
      return state;
  }
};
export default reduxTools;
